export const PPH23AccountCodesEnum = Object.freeze({
    SDAM : "SDAM",
    SUPPLIER : "Supplier"
});